import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 使用路由懒加载
const StageLayout = () => import('../views/StageLayout.vue')
const Layout = () => import('../views/Layout.vue')
const Home = () => import('../views/Home.vue')
const PackageIntroduction = () => import('../views/PackageIntroduction.vue')
const PackagePrivate = () => import('../views/PackagePrivate.vue')
const LegalInstrument = () => import('../views/LegalInstrument.vue')
const LegalKnowledge = () => import('../views/LegalKnowledge.vue')
const VideoCourses = () => import('../views/VideoCourses.vue')
const NotFound = () => import('../views/NotFound.vue')
const LegalDetail = () => import('../views/legaldetail.vue')
const PackageDetails = () => import('../views/PackageDetails.vue')
const PackageDetailsForDz = () => import('../views/PackageDetailsForDz.vue')
const UserPage = () => import('../views/stage/user.vue')
const MyService = () => import('../views/stage/MyService.vue')
const IncomeDetails = () => import('../views/stage/IncomeDetails.vue')
const MyVideo = () => import('../views/stage/MyVideo.vue')
const UserForClient = () => import('../views/stage/UserForClient.vue')
const MyDownload = () => import('../views/stage/MyDownload.vue')
const MyLawyer = () => import('../views/stage/MyLawyer.vue')
const MyOrder = () => import('../views/stage/MyOrder.vue')
const MyCoupon = () => import('../views/stage/Mycoupon.vue')
const MyTeam = () => import('../views/stage/MyTeam.vue')
const EntryApproval = () => import('../views/stage/EntryApproval.vue')
const Agreement = () => import('../views/Agreement.vue')
const Des = () => import('../views/Des.vue')
const MyInVoice = () => import('../views/stage/MyInVoice.vue')
const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: {
          title: '首页',
          keepAlive: true
        }
      },
      {
        path: 'legalinstrument',
        name: 'legalinstrument',
        component: LegalInstrument,
        meta: {
          title: '法律文书服务',
          keepAlive: false
        }
      },
      {
        path: 'legalknowledge',
        name: 'legalknowledge',
        component: LegalKnowledge,
        meta: {
          title: '法律知识',
          keepAlive: false
        }
      },
      {
        path: 'legaldetail',
        name: 'legaldetail',
        component: LegalDetail,
        meta: {
          title: '法律知识详情',
          keepAlive: false
        }
      },
      {
        path: 'packageDetails',
        name: 'packageDetails',
        component: PackageDetails,
        meta: {
          title: '法律服务套餐详情',
          keepAlive: false
        }
      },
      {
        path: 'packageDetailsForDz',
        name: 'packageDetailsForDz',
        component: PackageDetailsForDz,
        meta: {
          title: '专项服务',
          keepAlive: false
        }
      },
      {
        path: 'videoCourses',
        name: 'videoCourses',
        component: VideoCourses,
        meta: {
          title: '视频课程',
          keepAlive: false
        }
      },
      {
        path: 'agreement',
        name: 'agreement',
        component: Agreement,
        meta: {
          title: '协议',
          keepAlive: false
        }
      },
      {
        path: 'packageIntroduction',
        name: 'packageIntroduction',
        component: PackageIntroduction,
        meta: {
          title: '套餐详情',
          keepAlive: false
        }
      },
      {
        path: 'packagePrivate',
        name: 'packagePrivate',
        component: PackagePrivate,
        meta: {
          title: '套餐详情',
          keepAlive: false
        }
      },
      {
        path: 'des',
        name: 'des',
        component: Des,
        meta: {
          title: '底部导航栏',
          keepAlive: false
        }
      }
    ]
  },
  {
    path: '/stage',
    name: 'stage',
    redirect: '/stage/user',
    component: StageLayout,
    meta: {
      title: '个人中心',
      keepAlive: false
    },
    children: [
      {
        path: 'user',
        name: 'user',
        component: UserPage,
        meta: {
          title: '个人资料',
          keepAlive: false
        }
      },
      {
        path: 'myService',
        name: 'myService',
        component: MyService,
        meta: {
          title: '我的服务',
          keepAlive: false
        }
      },
      {
        path: 'incomeDetails',
        name: 'incomeDetails',
        component: IncomeDetails,
        meta: {
          title: '收入明细',
          keepAlive: false
        }
      },
      {
        path: 'myVideo',
        name: 'myVideo',
        component: MyVideo,
        meta: {
          title: '我的视频',
          keepAlive: false
        }
      },
      {
        path: 'userForClient',
        name: 'userForClient',
        component: UserForClient,
        meta: {
          title: '个人资料',
          keepAlive: false
        }
      },
      {
        path: 'myDownload',
        name: 'myDownload',
        component: MyDownload,
        meta: {
          title: '我的下载',
          keepAlive: false
        }
      },
      {
        path: 'myLawyer',
        name: 'myLawyer',
        component: MyLawyer,
        meta: {
          title: '我的律师',
          keepAlive: false
        }
      },
      {
        path: 'myOrder',
        name: 'myOrder',
        component: MyOrder,
        meta: {
          title: '我的订单',
          keepAlive: false
        }
      },
      {
        path: 'myCoupon',
        name: 'myCoupon',
        component: MyCoupon,
        meta: {
          title: '我的优惠券',
          keepAlive: false
        }
      },
      {
        path: 'myTeam',
        name: 'myTeam',
        component: MyTeam,
        meta: {
          title: '我的团队',
          keepAlive: false
        }
      },
      {
        path: 'entryApproval',
        name: 'entryApproval',
        component: EntryApproval,
        meta: {
          title: '入驻审批',
          keepAlive: false
        }
      },
      {
        path: 'myInVoice',
        name: 'myInVoice',
        component: MyInVoice,
        meta: {
          title: '我的发票',
          keepAlive: false
        }
      } 
    ]
  },
  // 添加404路由
  {
    path: '/404',
    name: 'notFound',
    component: NotFound,
    meta: {
      title: '页面未找到',
      keepAlive: false
    }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.VUE_APP_BASE_URL,
  routes,
  scrollBehavior() {
    // 页面切换时回到顶部
    return { x: 0, y: 0 }
  }
})

// 全局前置守卫，设置页面标题
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router 